// Logout.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";

const Logout = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // Automatically open the dialog when this component mounts
  useEffect(() => {
    setOpen(true);
  }, []);

  const handleClose = () => {
    setOpen(false);
    // For example, go back to a protected page if they cancel
    navigate("/dashboard");
  };

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    setOpen(false);
    navigate("/");
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Are you sure you want to log out?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Click "Yes" to log out, or "Cancel" to stay logged in.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleLogout} color="secondary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Logout;
